import secureLocalStorage from "react-secure-storage";

// secureLocalStorage.setItem("acessTokens", JSON.stringify(acessTokens));

let retrievedObject = JSON.parse(secureLocalStorage.getItem("acessTokens"));
let rsaData = JSON.parse(secureLocalStorage.getItem("rsa"));

// set data for admin
const adminAccessToken = retrievedObject?.adminAccessToken;
const admin_id = retrievedObject?.admin_id;

// set data for rsa
const rsaAccessToken = rsaData?.rsaAccessToken;
const rsa_id = rsaData?.rsa_id;

if (!retrievedObject) {
  retrievedObject = {};
}

if (!rsaData) {
  rsaData = {};
}

const initialState = {
  adminAccessToken: adminAccessToken ? adminAccessToken : null,
  admin_id: admin_id ? admin_id : null,
  rsaAccessToken: rsaAccessToken ? rsaAccessToken : null,
  rsa_id: rsa_id ? rsa_id : null,
};

const reducer = (state = initialState, action) => {
  if (action.type === "adminLogin") {
    retrievedObject.adminAccessToken = action.payload.adminAccessToken;
    retrievedObject.admin_id = action.payload.admin_id;
    secureLocalStorage.setItem("acessTokens", JSON.stringify(retrievedObject));

    return {
      ...state,
      adminAccessToken: action.payload.adminAccessToken,
      admin_id: action.payload.admin_id,
    };
  } else if (action.type === "adminLogOut") {
    delete retrievedObject?.admin_id;
    delete retrievedObject?.adminAccessToken;
    if (Object.keys(retrievedObject).length !== 0) {
      secureLocalStorage.setItem(
        "acessTokens",
        JSON.stringify(retrievedObject)
      );
    } else {
      secureLocalStorage.removeItem("acessTokens");
    }

    return {
      ...state,
      adminAccessToken: null,
      admin_id: null,
    };
  } else if (action.type === "rsaLogin") {
    rsaData.rsaAccessToken = action.payload.rsaAccessToken;
    rsaData.rsa_id = action.payload.rsa_id;
    secureLocalStorage.setItem("rsa", JSON.stringify(rsaData));

    return {
      ...state,
      rsaAccessToken: action.payload.rsaAccessToken,
      rsa_id: action.payload.rsa_id,
    };
  } else if (action.type === "rsaLogOut") {
    delete rsaData?.rsa_id;
    delete rsaData?.rsaAccessToken;

    secureLocalStorage.removeItem("rsa");

    return {
      ...state,
      rsaAccessToken: null,
      rsa_id: null,
    };
  } else {
    return state;
  }
};
export default reducer;
